<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <span class="ui grey">Home / eWallet</span>
        <h2 class="ui primary header">eWallet</h2>
      </div>
    </div>
  </div>

  <div class="ui divider"></div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div class="info">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#00A0AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <p
      style="
        color: #505050;
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      "
    >
      To activate your eWallet, select the currency account you wish to
      activate, then review and accept the terms and conditions.<br />
      Please note: Any amount deposited into your eWallet cannot be withdrawn.
    </p>
  </div>
  <div class="ui form" [ngClass]="{ loading: pending }">
    <div class="grouped fields">
      <h3 style="padding-bottom: 24px">
        Which currency do you want to activate?
      </h3>
      <div *ngFor="let row of currencies">
        <div class="field">
          <sui-checkbox
            [(ngModel)]="row.checked"
          >
            <h3 class="ui primary header">
              <span class="dollar-style">{{
                row.currencyLongName.includes("DOLLAR")
                  ? "US Dollar"
                  : transformString(row.currencyLongName)
              }}</span>
              Account
            </h3>
          </sui-checkbox>
          <!-- <sui-checkbox
            [(ngModel)]="row.checked"
            (ngModelChange)="onCheckboxChange(row)"
          >
            <h3 class="ui primary header">
              <span class="dollar-style">{{
                row.currencyLongName.includes("DOLLAR")
                  ? "US Dollar"
                  : transformString(row.currencyLongName)
              }}</span>
              Account
            </h3>
          </sui-checkbox> -->
        </div>
        <div class="ui divider"></div>
        <!-- <div class="account-details" *ngIf="row.checked">
          <p
            style="
              color: #505050;
              font-family: Roboto;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 19px;
            "
          >
            Fill in your bank account details here
          </p>

          <div
            class="field"
            appMargin
            marginB="15px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label>Beneficiary Name<span class="required-text">*</span></label>
            <div class="ui fluid input">
              <input
                type="text"
                placeholder="Enter beneficiary name"
                [(ngModel)]="row.accountName"
              />
            </div>
          </div>

          <div class="field" appMargin marginB="15px">
            <label
              >{{
                row.currencyLongName.includes("DOLLAR")
                  ? "Banking Institution"
                  : "Bank"
              }}<span class="required-text">*</span></label
            >
            <div class="ui fluid input">
              <sui-select
                class="selection"
                *ngIf="!row.currencyLongName.includes('DOLLAR')"
                [options]="row.banks"
                [isSearchable]="true"
                labelField="optionName"
                [(ngModel)]="row.selectedBank"
                #select
              >
                <sui-select-option
                  *ngFor="let option of select.filteredOptions"
                  [value]="option"
                >
                </sui-select-option>
              </sui-select>
              <input
                type="text"
                *ngIf="row.currencyLongName.includes('DOLLAR')"
                placeholder="Enter Bank"
                [(ngModel)]="row.selectedBank"
              />
            </div>
          </div>
          <div
            class="field"
            appMargin
            marginB="15px"
            *ngIf="!row.currencyLongName.includes('DOLLAR')"
          >
            <label>Account Name<span class="required-text">*</span></label>
            <div class="ui fluid input">
              <input
                type="text"
                placeholder="Enter account name"
                [(ngModel)]="row.accountName"
              />
            </div>
          </div>
          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
          >
            <label>Account Number<span class="required-text">*</span></label>
            <div class="ui fluid input">
              <input
                type="text"
                inputmode="numeric"
                pattern="[0-9]{5,12}"
                placeholder="Enter account number"
                [(ngModel)]="row.accountNumber"
              />
            </div>
          </div>

          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label>Currency<span class="required-text">*</span></label>
            <span class="currency-symbol">{{ row.currencyCode }} </span>
            <span class="currency-name">US Dollar</span>
          </div>
          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label
              >IBAN/Routing Number (Minimum of 5 digits and maximum of 12
              digit)</label
            >
            <div class="ui fluid input">
              <input
                type="text"
                inputmode="numeric"
                pattern="[0-9]{5,12}"
                placeholder="Enter IBAN"
                [(ngModel)]="row.ibanNumber"
              />
            </div>
          </div>

          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label>SWIFT or Sort Code (e.g 12-34-56)</label>
            <div class="ui fluid input">
              <input
                type="text"
                pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
                placeholder="Enter swift code"
                [(ngModel)]="row.sortCode"
              />
            </div>
          </div>

          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label>Intermediary Bank SWIFT Code (e.g 12-34-56)</label>
            <div class="ui fluid input">
              <input
                type="text"
                pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
                placeholder="Enter intermediary bank swift code"
                [(ngModel)]="row.intermediaryBankSwiftCode"
              />
            </div>
          </div>
          <div
            class="field"
            appMargin
            marginB="15px"
            style="padding-bottom: 8px"
            *ngIf="row.currencyLongName.includes('DOLLAR')"
          >
            <label>Bank Physical Address</label>
            <div class="ui fluid input">
              <input
                type="text"
                placeholder="Enter bank address"
                [(ngModel)]="row.bankAddress"
              />
            </div>
          </div>
        </div> -->
      </div>
      <div class="field" style="padding: 12px 0px 12px 0px">
        <sui-checkbox [(ngModel)]="agreementAccepted">
          <h4
            class="ui primary header"
            style="
              font-family: Roboto;
              font-size: 14px;
              font-weight: 500;
              line-height: 22px;
              letter-spacing: 0px;
              text-align: center;
            "
          >
            I agree to all
            <span class="tandc" (click)="openTandC($event)"
              >terms and conditions</span
            >
          </h4>
        </sui-checkbox>
      </div>
    </div>
    <button
      class="ui small button primary my-24 ui primary button"
      (click)="activateWallet()"
      [ngClass]="{ loading: pending }"
      [disabled]="
        !areConditionsMetForObjects(currencies) || !agreementAccepted || pending
      "
      autofocus
    >
      Activate my eWallet
    </button>
  </div>
</div>
